import BaseStore from '../../BaseStore';
import WOStatusModel from '../../../models/Maintenance/WorkOrder/WOStatusModel';

class WorkOrderStatusStore extends BaseStore {
  constructor(transportLayer) {
    super(WOStatusModel, transportLayer);
  }
}

export default WorkOrderStatusStore;


// WEBPACK FOOTER //
// ./src/stores/Maintenance/WorkOrder/WorkOrderStatusStore.js